
<div v-if="$vuetify.breakpoint.lgAndUp">
	<v-menu offset-y close-on-click style="overflow-y: auto !important">
		<template #activator="{ on, attrs }">
			<v-list-item v-bind="attrs" v-on="on">
				<v-list-item-avatar v-if="!avatar" horizontal>
					<v-img :src="no_avatar"></v-img>
				</v-list-item-avatar>
				<v-list-item-avatar v-else horizontal size="56">
					<v-img :src="avatar"></v-img>
				</v-list-item-avatar>

				<v-list-item-content>
					<v-list-item-title v-if="user" color="red" :style="`color: ${customColor} !important;`" class="text--secondary font-weight-bold">{{
						usersName
					}}</v-list-item-title>
					<v-list-item-subtitle :style="`color: ${customColor} !important;`">{{ usersProfession }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</template>
		<v-card elevation="3" style="overflow-y: hidden !important; overflow-x: hidden !important">
			<v-card-actions>
				<v-row>
					<v-col>
						<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :disabled="profileDisabled" router to="/locum/profile" color="secondary" block>Edit Profile</v-btn></v-row>
						<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn router color="secondary" block @click="openLocumPreview">Preview Profile</v-btn></v-row>

						<v-row class="pb-0 ml-1 mr-1 ma-3"
							><v-btn :disabled="accountDisabled" router to="/locum/account-settings" color="secondary" block>Account Settings</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :loading="apiRequest" router :href="menuLinks.faq" target="_blank" color="secondary" block>FAQ</v-btn></v-row>
						<v-row class="pb-0 ml-1 mr-1 ma-3"
							><v-btn :loading="apiRequest" router :href="menuLinks.blog" target="_blank" color="secondary" block>Blog</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"
							><v-btn :loading="apiRequest" router :href="menuLinks.contact" target="_blank" color="secondary" block>Contact Us</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :loading="apiRequest" color="secondary" block @click="signOut">Sign Out</v-btn></v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-menu>
</div>
